module.exports = __webpack_public_path__ + "static/img/Landing Page_íconoÍcono_plataforma pie niño inside.06ee7eac.svg";